import { useState } from "react";

import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import Joi from "joi-browser";
import { putModelSettings } from "../../service";
import { message } from "antd";
import { Button } from "V2.0/common/button";

const getPromptSchema = (promptCharacterLimit = 30000) => ({
  rawPrompt: Joi.string()
    .max(promptCharacterLimit)
    .required()
    .label("Raw prompt"),
});

function PromptSettings({
  modelSettings,
  syncAssistant,
  workspaceId,
  assistantId,
  locked,
}) {
  const { rawPrompt, promptCharacterLimit } = modelSettings?.promptSettings;

  const [inputField] = useState({ rawPrompt: rawPrompt.split("Context:")[0] });
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage] = useState({});
  const [notifyChange, setNotifyChange] = useState(false);
  const { data, setData, error, setError, handleChange, validate } = useForm(
    inputField,
    getPromptSchema(promptCharacterLimit),
    () => setNotifyChange(true),
  );

  const handleCustomPrompt = async () => {
    const errors = validate(data, getPromptSchema(promptCharacterLimit));

    if (errors) {
      setError(errors);
      return;
    }

    setLoading(true);
    message.loading("Saving prompt");
    const payload = {
      promptSettings: data,
    };
    try {
      const response = await putModelSettings({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Prompt saved");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            modelSettings: response.data,
          };
        });
        setLoading(false);
        setNotifyChange(false);
      }
    } catch (e) {
      message.destroy();
      message.error(
        e?.response?.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to update prompt",
      );
      console.error("Error updating prompt");
      setLoading(false);
    }
  };

  const template = [
    {
      name: "rawPrompt",
      type: "textArea",
      style: { fontSize: "14px" },
      disabled: locked,
    },
  ];

  const disableSavePrompt = !notifyChange || Object.keys(error).length > 0;

  return (
    <div className="flex flex-col w-full h-full gap-y-4 p-4">
      <div className="h-full flex-1 w-full">
        <Form
          data={data}
          handleChange={handleChange}
          error={error}
          template={template}
        />
      </div>
      {!locked && (
        <div className="flex shrink-0 gap-x-2">
          <Button
            loading={loading}
            disabled={disableSavePrompt}
            onClick={handleCustomPrompt}
          >
            Save Prompt
          </Button>
          {notifyChange && (
            <Button
              outline
              onClick={() => {
                setData({ rawPrompt });
                setNotifyChange(false);
                message.success("Changes Reverted");
              }}
            >
              Revert
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export { PromptSettings };
